const initSnowFall = () => {
  const canvases = document.querySelectorAll('.snow-fall-canvas');

  canvases.forEach(canvas => {
    // Prevent double initialization
    if (canvas.dataset.initialized) {
      // If in theme editor, we might want to re-init, so clear context or handle resize. 
      // But simpler to just mark initialized. 
      // Actually, for theme editor 'shopify:section:load', the bad practice is adding listeners multiple times.
      // We will just let it run but ensure we don't add duplicate resize listeners if possible or rely on closures.
      // Better: check if already initialized, if so, maybe just return or clear.
      // For simplicity and since 'shopify:section:load' implies re-render of HTML, the canvas is likely new.
      // The only risk is if we call initSnowFall() multiple times on existing static canvases.
      if (canvas.dataset.initialized === "true") return;
    }
    canvas.dataset.initialized = "true";

    const ctx = canvas.getContext('2d');

    let width = window.innerWidth;
    let height = window.innerHeight;

    canvas.width = width;
    canvas.height = height;

    // Read settings from data attributes
    const particleCount = parseInt(canvas.dataset.density, 10) || 100;
    const speedMultiplier = (parseInt(canvas.dataset.speed, 10) || 2) / 5;
    const snowColor = canvas.dataset.color || "#ffffff";
    const imageUrl = canvas.dataset.image;

    let particleImage = null;
    if (imageUrl) {
      particleImage = new Image();
      particleImage.src = imageUrl;
    }

    const particles = [];

    class Snowflake {
      constructor() {
        this.x = Math.random() * width;
        this.y = Math.random() * height;
        this.vx = (Math.random() - 0.5) * speedMultiplier;
        this.vy = (Math.random() * 1 + 0.5) * speedMultiplier;
        this.size = Math.random() * 3 + 1;
        this.opacity = Math.random() * 0.5 + 0.3;
        // Add random rotation and rotation speed for images
        this.rotation = Math.random() * 360;
        this.rotationSpeed = (Math.random() - 0.5) * 2;
        // Scale images slightly larger
        this.imageSize = this.size * 5 + 5;
      }

      update() {
        this.x += this.vx;
        this.y += this.vy;
        this.rotation += this.rotationSpeed;

        // Wrap around screen
        if (this.y > height) {
          this.y = -10;
          this.x = Math.random() * width;
        }
        if (this.x > width) {
          this.x = 0;
        } else if (this.x < 0) {
          this.x = width;
        }
      }

      draw() {
        ctx.globalAlpha = this.opacity;

        if (particleImage && particleImage.complete) {
          ctx.save();
          ctx.translate(this.x, this.y);
          ctx.rotate(this.rotation * Math.PI / 180);
          ctx.drawImage(particleImage, -this.imageSize / 2, -this.imageSize / 2, this.imageSize, this.imageSize);
          ctx.restore();
        } else {
          ctx.beginPath();
          ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
          ctx.fillStyle = snowColor;
          ctx.fill();
        }

        ctx.globalAlpha = 1.0;
      }
    }

    function init() {
      for (let i = 0; i < particleCount; i++) {
        particles.push(new Snowflake());
      }
    }

    function animate() {
      ctx.clearRect(0, 0, width, height);

      particles.forEach(p => {
        p.update();
        p.draw();
      });

      requestAnimationFrame(animate);
    }

    // Handle resize
    const resizeHandler = function () {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
    };
    window.addEventListener('resize', resizeHandler);

    init();
    animate();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSnowFall);
} else {
  initSnowFall();
}

document.addEventListener('shopify:section:load', initSnowFall);